import React from "react";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen w-full max-w-full mx-auto px-4 sm:px-6 lg:px-8 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 font-sans antialiased transition-colors duration-300 ease-in-out">
      {children}
    </div>
  );
};

export default Layout;
